/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseSector } from '../models/BaseSector';
import type { EditShiftTimes } from '../models/EditShiftTimes';
import type { ShiftIn } from '../models/ShiftIn';
import type { SimpleShiftWithAddedStatus } from '../models/SimpleShiftWithAddedStatus';
import type { SimpleShiftWithEditReason } from '../models/SimpleShiftWithEditReason';
import type { SimpleShiftWithRemovedStatus } from '../models/SimpleShiftWithRemovedStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ShiftsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Edit Shift Worked Hours And Break Time
     * ### Edit shift times
     *
     * Edit the start- end- and break time of a shift.
     *
     * **Permissions Required**:
     * `edit_hours`
     * ***found in:***
     * - `permission:can_manage_shifts`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **shift_id**: `int` object, fetched by the path parameter.
     * - **start_time**: `time` object to set the new start time.
     * - **end_time**: `time` object to set the new end time.
     * - **break_time**: `time` object to set the new break time.
     * - **edit_reason**: `str` object to provide a reason for the edit.
     *
     * **Returns**:
     * - `Shift`: The corrected shift.
     *
     * **Raises**:
     * - `422`: If the end_time is before the start_time.
     * - `400`: If the shift does not have a coach.
     * - `400`: If a coach tries to edit a shift that has not passed yet.
     * - `400`: If Office tries to edit a shift that is not in the current week without providing a reason.
     * -
     * @param shiftId
     * @param requestBody
     * @param editReason
     * @returns SimpleShiftWithEditReason Successful Response
     * @throws ApiError
     */
    public patchFspEditShiftWorkedHoursAndBreakTime(
        shiftId: number,
        requestBody: EditShiftTimes,
        editReason?: (string | null),
    ): CancelablePromise<SimpleShiftWithEditReason> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/fsp/shifts/shift/{shift_id}/edit/worked_hours',
            path: {
                'shift_id': shiftId,
            },
            query: {
                'edit_reason': editReason,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Coach From Shift
     * ### Remove coach from shift
     *
     * Remove a coach from a shift.
     *
     * **Permissions Required**:
     * `edit_hours`
     * ***found in:***
     * - `permission:can_manage_shifts`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **shift_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `Shift`: The corrected shift.
     *
     * **Raises**:
     * - `400`: If the shift does not have a coach.
     * - `400`: If a coach tries to edit a shift that has not passed yet.
     * @param shiftId
     * @returns SimpleShiftWithRemovedStatus Successful Response
     * @throws ApiError
     */
    public patchFspRemoveCoachFromShift(
        shiftId: number,
    ): CancelablePromise<SimpleShiftWithRemovedStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/fsp/shifts/shift/{shift_id}/edit/accord/remove',
            path: {
                'shift_id': shiftId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Coach Worked Sectors
     * ### Get worked sectors of a coach
     *
     * Get all sectors the coach has worked in.
     *
     * **Permissions Required**:
     * `view`
     * ***found in:***
     * - `permission:can_manage_jobs`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **coach_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `List[BaseSector]`: The sectors the coach has worked in.
     * @param coachId
     * @returns BaseSector Successful Response
     * @throws ApiError
     */
    public getFspGetCoachWorkedSectors(
        coachId: number,
    ): CancelablePromise<Array<BaseSector>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/fsp/shifts/coach/{coach_id}/worked_sectors',
            path: {
                'coach_id': coachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Shift To Accord
     * ### Add a shift to a coach,
     *
     * Add a coach to a shift.
     *
     * **Permissions Required**:
     * `edit_hours`
     * `view`
     * ***found in:***
     * - `permission:can_manage_jobs`
     * - `permission:can_manage_shifts`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **shift_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `Shift`: The corrected shift.
     *
     * **Raises**:
     * - `400`: If the coach has not yet worked at the selected branch, and the user is not from the office.
     * - `400`: If the shift-date is set on today/after today and the user is not from the office.
     * @param coachId
     * @param branchId
     * @param sectorId
     * @param requestBody
     * @returns SimpleShiftWithAddedStatus Successful Response
     * @throws ApiError
     */
    public postFspAddShiftToAccord(
        coachId: number,
        branchId: number,
        sectorId: number,
        requestBody: ShiftIn,
    ): CancelablePromise<SimpleShiftWithAddedStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/fsp/shifts/shift/edit/accord/add/branch/{branch_id}/sector/{sector_id}/coach/{coach_id}',
            path: {
                'coach_id': coachId,
                'branch_id': branchId,
                'sector_id': sectorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Edit Shift Worked Hours And Break Time
     * ### Edit shift times
     *
     * Edit the start- end- and break time of a shift.
     *
     * **Permissions Required**:
     * `edit_hours`
     * ***found in:***
     * - `permission:can_manage_shifts`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **shift_id**: `int` object, fetched by the path parameter.
     * - **start_time**: `time` object to set the new start time.
     * - **end_time**: `time` object to set the new end time.
     * - **break_time**: `time` object to set the new break time.
     * - **edit_reason**: `str` object to provide a reason for the edit.
     *
     * **Returns**:
     * - `Shift`: The corrected shift.
     *
     * **Raises**:
     * - `422`: If the end_time is before the start_time.
     * - `400`: If the shift does not have a coach.
     * - `400`: If a coach tries to edit a shift that has not passed yet.
     * - `400`: If Office tries to edit a shift that is not in the current week without providing a reason.
     * -
     * @param shiftId
     * @param requestBody
     * @param editReason
     * @returns SimpleShiftWithEditReason Successful Response
     * @throws ApiError
     */
    public patchFspEditShiftWorkedHoursAndBreakTimeVLatest(
        shiftId: number,
        requestBody: EditShiftTimes,
        editReason?: (string | null),
    ): CancelablePromise<SimpleShiftWithEditReason> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/fsp/shifts/shift/{shift_id}/edit/worked_hours',
            path: {
                'shift_id': shiftId,
            },
            query: {
                'edit_reason': editReason,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Remove Coach From Shift
     * ### Remove coach from shift
     *
     * Remove a coach from a shift.
     *
     * **Permissions Required**:
     * `edit_hours`
     * ***found in:***
     * - `permission:can_manage_shifts`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **shift_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `Shift`: The corrected shift.
     *
     * **Raises**:
     * - `400`: If the shift does not have a coach.
     * - `400`: If a coach tries to edit a shift that has not passed yet.
     * @param shiftId
     * @returns SimpleShiftWithRemovedStatus Successful Response
     * @throws ApiError
     */
    public patchFspRemoveCoachFromShiftVLatest(
        shiftId: number,
    ): CancelablePromise<SimpleShiftWithRemovedStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/latest/fsp/shifts/shift/{shift_id}/edit/accord/remove',
            path: {
                'shift_id': shiftId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Coach Worked Sectors
     * ### Get worked sectors of a coach
     *
     * Get all sectors the coach has worked in.
     *
     * **Permissions Required**:
     * `view`
     * ***found in:***
     * - `permission:can_manage_jobs`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **coach_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `List[BaseSector]`: The sectors the coach has worked in.
     * @param coachId
     * @returns BaseSector Successful Response
     * @throws ApiError
     */
    public getFspGetCoachWorkedSectorsVLatest(
        coachId: number,
    ): CancelablePromise<Array<BaseSector>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/latest/fsp/shifts/coach/{coach_id}/worked_sectors',
            path: {
                'coach_id': coachId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Add Shift To Accord
     * ### Add a shift to a coach,
     *
     * Add a coach to a shift.
     *
     * **Permissions Required**:
     * `edit_hours`
     * `view`
     * ***found in:***
     * - `permission:can_manage_jobs`
     * - `permission:can_manage_shifts`
     * - `User` == matching `Shift`
     *
     * **Parameters**:
     * - **shift_id**: `int` object, fetched by the path parameter.
     *
     * **Returns**:
     * - `Shift`: The corrected shift.
     *
     * **Raises**:
     * - `400`: If the coach has not yet worked at the selected branch, and the user is not from the office.
     * - `400`: If the shift-date is set on today/after today and the user is not from the office.
     * @param coachId
     * @param branchId
     * @param sectorId
     * @param requestBody
     * @returns SimpleShiftWithAddedStatus Successful Response
     * @throws ApiError
     */
    public postFspAddShiftToAccordVLatest(
        coachId: number,
        branchId: number,
        sectorId: number,
        requestBody: ShiftIn,
    ): CancelablePromise<SimpleShiftWithAddedStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/latest/fsp/shifts/shift/edit/accord/add/branch/{branch_id}/sector/{sector_id}/coach/{coach_id}',
            path: {
                'coach_id': coachId,
                'branch_id': branchId,
                'sector_id': sectorId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
